
<div class="content-detail-row l_rwd">
  <slot></slot>
</div>
